import { classes } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

if (!customElements.get('back-in-stock'))
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLCustomElement {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.on('submit', this.targets.form, async (event) => {
          const form = new FormData(event.target);

          event.preventDefault();

          this.showSuccess(false);
          this.showError(false);

          this.targets.submit.disabled = true;

          await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UMAyMh`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-10-15',
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: form.get('email'),
                      },
                    },
                  },
                  channels: ['EMAIL'],
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: `$shopify:::$default:::${form.get('variant')}`,
                    },
                  },
                },
              },
            }),
          })
            .then((response) => {
              this.targets.submit.disabled = false;

              if (response.ok) {
                this.showSuccess();
              } else {
                this.showError();
              }
            })
            .catch((error) => {
              console.error(error);
            });
        });
      }

      /**
       * Shows the success state.
       * @param {Boolean} show - Set to false to revert.
       */
      showSuccess(show = true) {
        this.targets.success.classList[show ? 'add' : 'remove'](classes.active);
        this.targets.error.classList.remove(classes.active);
      }

      /**
       * Shows the error state.
       * @param {Boolean} show - Set to false to revert.
       */
      showError(show = true) {
        this.targets.error.classList[show ? 'add' : 'remove'](classes.active);
        this.targets.success.classList.remove(classes.active);
      }
    }
  );
